import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { CheckCircle, Clock, AlertCircle, Loader } from "lucide-react";
import { SWAP_PROGRESS_STATUS } from "../../../constants/swapData";

const STATUS_CONFIG = {
  completed: {
    icon: CheckCircle,
    iconColor: "#22c55e",
    bgColor: "rgba(220, 252, 231, 1)",
    textColor: "success.main",
  },
  loading: {
    icon: Loader,
    iconColor: "#3b82f6",
    bgColor: "rgba(219, 234, 254, 1)",
    textColor: "primary.main",
    animated: true,
  },
  error: {
    icon: AlertCircle,
    iconColor: "#ef4444",
    bgColor: "rgba(254, 226, 226, 1)",
    textColor: "error.main",
  },
  pending: {
    icon: Clock,
    iconColor: "#9ca3af",
    bgColor: "white",
    textColor: "text.secondary",
  },
};

const SwapProgress = ({ progressSteps, swapStatus, isSwapTimeout }) => {
  console.log("swapStatus: ", swapStatus);
  const getEffectiveStatus = (stepStatus, id) => {
    if (
      id === 3 &&
      (swapStatus === SWAP_PROGRESS_STATUS.SWAP_INCOMPLETE ||
        swapStatus === SWAP_PROGRESS_STATUS.SWAP_FAILED)
    )
      return "error";

    if (swapStatus === SWAP_PROGRESS_STATUS.SWAP_COMPLETED) return "completed";

    if (isSwapTimeout && swapStatus !== SWAP_PROGRESS_STATUS.SWAP_INCOMPLETE)
      return "error";

    if (swapStatus === SWAP_PROGRESS_STATUS.SWAP_FAILED) return "error";

    return stepStatus;
  };

  const renderStatusIcon = (stepStatus, id) => {
    const effectiveStatus = getEffectiveStatus(stepStatus, id);
    const config = STATUS_CONFIG[effectiveStatus] || STATUS_CONFIG.pending;
    const IconComponent = config.icon;

    return (
      <IconComponent
        size={20}
        color={config.iconColor}
        className={config.animated ? "animate-spin" : ""}
      />
    );
  };

  const getStatusConfig = (stepStatus, id) => {
    const effectiveStatus = getEffectiveStatus(stepStatus, id);
    return STATUS_CONFIG[effectiveStatus] || STATUS_CONFIG.pending;
  };

  return (
    <Box maxWidth="lg" my={2}>
      <Typography variant="body1" fontWeight={600} mb={2}>
        Swap Progress
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {progressSteps.map((step) => {
          const StepIcon = step.icon;
          const statusConfig = getStatusConfig(step.status, step.id);

          return (
            <Paper
              key={step.id}
              elevation={0}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 2,
                border: "1px solid #e5e7eb",
                borderRadius: 2,
                bgcolor: statusConfig.bgColor,
                transition: "all 0.3s ease",
              }}
            >
              <Box sx={{ mr: 2, display: "flex", alignItems: "center" }}>
                {renderStatusIcon(step.status, step.id)}
              </Box>

              <Box sx={{ flexGrow: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: statusConfig.textColor,
                  }}
                >
                  {step.name}
                </Typography>
              </Box>

              <Box sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                <StepIcon size={18} color={statusConfig.iconColor} />
              </Box>
            </Paper>
          );
        })}
      </Box>

      {/* CSS for animations */}
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
      `}</style>
    </Box>
  );
};

export default SwapProgress;
